module.exports = __webpack_public_path__ + "img/ouzoEN.21b1bd08.jpg";